/**
 * The product model version a variant selects to use Leena-2 results.
 *
 * It names the Leena-2 product model, not a snapshot of its data: Leena-2
 * results are versioned per product (`product_revision`, PLT-7043), and a
 * variant on this version records which revision of each of its products it
 * used (`variant_product_revision`). Reads "at this version" that are not
 * tied to a variant see each product's latest revision. The product graph,
 * labels and market sizes for such a variant come from its release's regular
 * product model version (`resolveLeena2GraphVersion`).
 */
export const LEENA2_PRODUCT_MODEL_VERSION = '2.0.0';

export function isLeena2ProductModelVersion(version: string | null | undefined): boolean {
  return version === LEENA2_PRODUCT_MODEL_VERSION;
}

/**
 * Debug-only product model version under which the leaf-sum parent rollup
 * writes non-leaf scores. The authoritative non-leaf scores are produced
 * directly via comparisons at `LEENA2_PRODUCT_MODEL_VERSION`; the rollup never
 * overrides them. This separate version keeps the leaf-sum aggregate viewable
 * for debugging / comparison (query `impact_score` at this version), since leaf
 * lists may be incomplete and per-leaf market sizes are rough estimates.
 *
 * For a custom product model version `v`, the rollup writes at `${v}-rollup`.
 */
export const LEENA2_ROLLUP_DEBUG_SUFFIX = '-rollup';

/** The rollup-debug version string for a given leena-2 product model version. */
export function rollupDebugVersion(version: string): string {
  return `${version}${LEENA2_ROLLUP_DEBUG_SUFFIX}`;
}

/** Convenience constant for the default model version's rollup-debug version. */
export const LEENA2_ROLLUP_DEBUG_VERSION = rollupDebugVersion(LEENA2_PRODUCT_MODEL_VERSION);
